import { render, staticRenderFns } from "./carLoss.vue?vue&type=template&id=335ec550&scoped=true"
import script from "./carLoss.vue?vue&type=script&lang=js"
export * from "./carLoss.vue?vue&type=script&lang=js"
import style0 from "./carLoss.vue?vue&type=style&index=0&id=335ec550&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "335ec550",
  null
  
)

export default component.exports